
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 49 72"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"fill":"#BF9C5F","d":"M19.217 27.784l-4.328 4.328c-.031 0-.06-.01-.094-.01a3.788 3.788 0 00-3.783 3.783v19.482a3.76 3.76 0 001.174 2.726L1.257 69.843a1.08 1.08 0 101.582 1.471L13.716 59.62v10.957a1.08 1.08 0 002.158 0V59.62L26.74 71.31a1.08 1.08 0 101.584-1.469L17.4 58.087a3.768 3.768 0 001.171-2.723v-7.508h2.457v.812a1.08 1.08 0 002.158 0V44.88a1.08 1.08 0 00-2.158 0v.815h-2.457v-9.81a3.757 3.757 0 00-1.45-2.953l3.62-3.619c4.428.23-1.749-5.952-1.525-1.53zm-6.041 8.101c0-.892.726-1.621 1.621-1.621.893 0 1.622.726 1.622 1.621v19.482c0 .892-.726 1.621-1.622 1.621a1.623 1.623 0 01-1.621-1.621V35.885z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M9.77 18.74c0 .598.481 1.08 1.078 1.08 4.483.005 8.145 3.541 8.37 7.964l1.524 1.529c4.428.23 7.964 3.892 7.964 8.366 0 .58.525 1.08 1.079 1.08 4.626.005 8.391 3.77 8.391 8.388a1.078 1.078 0 001.843.763c10.63-10.627 10.894-27.674.746-38.623l1.082-1.082A1.08 1.08 0 1040.32 6.68L39.238 7.76C28.304-2.373 11.251-2.13.616 8.507a1.08 1.08 0 00.763 1.845c4.625.006 8.39 3.77 8.39 8.389zm3.633-.766c5.935-4.56 18.35-12.163 24.222-8.598L21.132 25.87c-.896-3.923-3.958-6.95-7.73-7.895zm17.153 17.151c-1.311-4.084-3.627-6.747-7.898-7.723l16.5-16.5c2.637 4.337-.827 14.09-8.602 24.223zm9.491 9.563a10.588 10.588 0 00-8.096-7.855c6.572-8.44 10.177-16.45 10.216-22.167 5.706 9.164 5.155 21.346-2.12 30.022zM33.82 6.338c-5.757.06-13.915 3.848-22.123 10.23a10.583 10.583 0 00-7.858-8.08C12.579 1.157 24.76.72 33.82 6.337z"}})])])
          )
        }
      }
    